<template>
  <label class="faq-form__checker checker">
    <input v-model="check" class="checker__input" type="checkbox" />
    <span class="checker__check">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Interface / Check">
          <path
            id="Vector"
            d="M6 12L10.2426 16.2426L18.727 7.75732"
            stroke="#000000"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </span>
    <span class="checker__text">
      Я соглашаюсь с политикой
      <NuxtLink to="/privacy">обработки персональных данных</NuxtLink>
    </span>
  </label>
</template>

<script setup>
const check = ref(true)
</script>
